import React from 'react'

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="d-flex flex-row justify-content-between">
        <div>
          <span> Copyright Scripto &copy; 2018</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./components/Footer/index.js